import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Tabs, Tab } from "react-bootstrap";

import { caloriesBurnedSteps } from "./formHelper";

const CaloriesBurnedTabs = () => {
	const [activeTab, setActiveTab] = useState(0);

	const renderTabs = () => {
		return (
			caloriesBurnedSteps &&
			caloriesBurnedSteps.map((step, i) => {
				const SpecificStep = step.component;
				return (
					<Tab key={step.id} eventKey={i} title={step.title}>
						<SpecificStep setActiveTab={setActiveTab} />
					</Tab>
				);
			})
		);
	};

	return (
		<React.Fragment>
			<Tabs activeKey={activeTab} className="pt-2 border-0" onSelect={(tabNumber) => setActiveTab(Number(tabNumber))}>
				{renderTabs()}
			</Tabs>
		</React.Fragment>
	);
};

const mapDispatchToProps = {};

export default connect(
	null,
	mapDispatchToProps
)(withRouter(CaloriesBurnedTabs));
